const drawDynamicProgressBar = (ctx, cx, cy, lineLength, radius, progressValue) => {
    for (let i = 1.5 * Math.PI, max = ((1.5 * Math.PI) + (progressValue * 2 * Math.PI /100)), step = (Math.PI / 30); i < max; i += step) {
        let x1 = cx + Math.cos(i) * radius;
        let y1 = cy + Math.sin(i) * radius;
        let x2 = cx + Math.cos(i) * (radius + lineLength);
        let y2 = cy + Math.sin(i) * (radius + lineLength);

        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = "4";
        ctx.strokeStyle = "#43E00C";
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
    }
};

export default drawDynamicProgressBar